module.exports = __webpack_public_path__ + "static/media/icon-briefcase-active.31149c29.svg";